import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import {
  createPatientEditFormDataStore,
  PatientEditFormDataState,
  PatientEditFormDataStoreApi,
} from '../stores/createPatientEditFormDataStore';

/**
 * 환자 수정 폼 store를 하위 트리에 주입한다.
 * 소유 컴포넌트(PatientEditDialog)가 Patient로 store를 생성해 주입한다.
 */
const PatientEditFormContext = createContext<PatientEditFormDataStoreApi | null>(null);

export const PatientEditFormProvider: FC<{ store: PatientEditFormDataStoreApi; children: ReactNode }> = ({
  store,
  children,
}) => {
  return <PatientEditFormContext.Provider value={store}>{children}</PatientEditFormContext.Provider>;
};

export function usePatientEditFormStore<U>(selector: (s: PatientEditFormDataState) => U): U {
  return useStore(usePatientEditFormStoreApi(), selector);
}

/** 액션 핸들러에서 최신 store state를 직접 읽기 위해 store api 자체가 필요할 때 사용한다. */
export function usePatientEditFormStoreApi(): PatientEditFormDataStoreApi {
  const store = useContext(PatientEditFormContext);
  if (!store) {
    throw new Error('usePatientEditFormStoreApi must be used within PatientEditFormProvider');
  }
  return store;
}
